import React from 'react';

const VOICES = [
  {
    quote:
      'Entnervt nach mehrmaligem Verwalterwechsel haben wir uns für die hamba GmbH entschieden. Wir sind sehr zufrieden mit den Leistungen und der Kommunikation. So eine unkomplizierte Zusammenarbeit haben wir uns schon immer gewünscht.',
    name: 'Simone S.',
    role: '10 Einheiten in Frankfurt a.M.',
  },
  {
    quote:
      'Das Angebot von hamba war attraktiv und genau auf unsere Bedürfnisse zugeschnitten. Die Übernahme der Aufgaben von der Vorgängerfirma, die einige „offene Baustellen“ hinterlassen hatte, wurde professionell und engagiert angegangen. Wir sind sehr zufrieden mit der sachlich-konstruktiven und verlässlichen Zusammenarbeit.',
    name: 'Michael S. & Andreas S.',
    role: '10 Einheiten in Königstein i.Ts.',
  },
  {
    quote:
      'Von Anfang an hatte ich das Gefühl, dass hier professionell, zuverlässig und mit viel Engagement gearbeitet wird. Besonders positiv finde ich, dass Anliegen nicht „auf später“ geschoben werden. Insgesamt eine sehr kompetente Verwaltung, bei der man nicht das Gefühl hat, nur eine Nummer zu sein.',
    name: 'Emre H.',
    role: '7 Einheiten in Hochheim a.M.',
  },
  {
    quote:
      'hamba ist eine engagierte, proaktive Verwaltung mit sehr guter, persönlicher Kommunikation und breitem Serviceangebot. Die Zusammenarbeit erleben wir als durchweg positiv und professionell.',
    name: 'Sebastian S.',
    role: '8 Einheiten in Mainz',
  },
];

function Voice({ voice, className = '' }) {
  return (
    <figure className={`voice reveal ${className}`.trim()}>
      <div className="voice__mark" aria-hidden="true">
        &ldquo;
      </div>
      <blockquote className="voice__quote">{voice.quote}</blockquote>
      <figcaption className="voice__by">
        <span>{voice.name}</span>
        <span className="voice__role">{voice.role}</span>
      </figcaption>
    </figure>
  );
}

export default function Testimonials() {
  // An odd trailing quote is rendered outside the grid rather than spanning it.
  // `.voices` equalises every row, so a solo quote inside it would be stretched
  // to the height of the longest quote on the page — leaving a block of dead
  // space right before the next section. Outside, it sizes to its own text.
  const hasTrailing = VOICES.length % 2 === 1;
  const paired = hasTrailing ? VOICES.slice(0, -1) : VOICES;
  const trailing = hasTrailing ? VOICES[VOICES.length - 1] : null;

  return (
    <section style={{ padding: '140px 0', background: 'var(--cream-deep)' }}>
      <div className="shell">
        <div className="section-label numbered reveal" style={{ marginBottom: 28 }}>
          <span>Weitere Kundenstimmen</span>
        </div>
        {/* No max-width: the headline fits one line at any desktop width and
            wraps on its own once the viewport is narrower. */}
        <h2 className="h-section reveal" style={{ marginBottom: 16, textWrap: 'balance' }}>
          Was unsere Kunden sagen.
        </h2>

        {/* Layout in homev2.css (.voices / .voice): equal-height 2-col matrix,
            single column below 720px. */}
        <div className="voices">
          {paired.map((v) => (
            <Voice key={v.name} voice={v} />
          ))}
        </div>
        {trailing && <Voice voice={trailing} className="voice--wide" />}
      </div>
    </section>
  );
}
